import { render, staticRenderFns } from "./PostReply.vue?vue&type=template&id=858f410e&scoped=true"
import script from "./PostReply.vue?vue&type=script&lang=js"
export * from "./PostReply.vue?vue&type=script&lang=js"
import style0 from "./PostReply.vue?vue&type=style&index=0&id=858f410e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858f410e",
  null
  
)

export default component.exports